import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  UpgradableNumber,
  WeaponDamageUpgradeFeature,
  WeaponLimitation,
} from "@dndModels";

import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";

interface Props { 
  obj: WeaponDamageUpgradeFeature;
  onChange: (changed: WeaponDamageUpgradeFeature) => void;
  disabled?: boolean;
  attached_table?: AttachedTable;
}

export default function WeaponDamageUpgradeFeatureInput({ 
  obj,
  onChange,
  disabled = false,
  attached_table
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <WeaponLimitInput
          obj={myObj.weapon_limit}
          disabled={disabled}
          onChange={(changed: WeaponLimitation) => {
            const new_obj = myObj;
            new_obj.weapon_limit = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <UpgradableNumberBox 
          name="Damage Dice Count"
          value={myObj.damage_rolls.count.clone()} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = myObj;
            new_obj.damage_rolls.count = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <UpgradableNumberBox 
          name="Damage Dice Size"
          value={myObj.damage_rolls.size.clone()} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = myObj;
            new_obj.damage_rolls.size = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  );
}
